import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

const GET_ALL_ACCOUNTS = gql`
  query GetAllAccounts {
    getAllAccounts {
      id
      business_dba
    }
  }
`;

export function useAccountSearch() {
  const { data, loading } = useQuery(GET_ALL_ACCOUNTS, {
    fetchPolicy: 'cache-and-network',
  });

  const accounts =
    data?.getAllAccounts?.map((account) => ({
      value: account.id,
      label: account.business_dba,
    })) || [];

  return { accounts, loading };
}
